import ApiBase from '../../../features/shared/services/ApiBase';
import UserStatus from '../UserStatus';

export default class UsersApi extends ApiBase {
  list() {
    return this.http.get('users/list');
  }

  edit(userId) {
    return this.http.get(`users/${userId}`);
  }

  update(user) {
    return this.http.put(`users/${user.id}`, user);
  }

  setUserPassword(model) {
    return this.http.put(`users/${model.userId}/password`, model);
  }

  disable(userId) {
    return this.http.put(`users/${userId}/status`, {status: UserStatus.disabled});
  }

  enable(userId) {
    return this.http.put(`users/${userId}/status`, {status: UserStatus.enabled});
  }
}



// WEBPACK FOOTER //
// ./app/features/users/services/UsersApi.js